export const environment = {
	production: true,
	name: 'admin-ui',
	app: 'widget',
	env: undefined,
	version: undefined,
	endpoints: undefined
};
